import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Subcategory, subcategoryType } from '../../types/slices/subcategoryType'

const initialState: subcategoryType =
{
    status: ApiStatus.FETCHED,
    subCategories: [],
    subcategoriesWithProducts: [],
    subCategorySelected: {} as Subcategory,
    errorMessage: undefined,
    action: ''
}

const subcategorySlice = createSlice({
    name: 'subcategorySlice',
    initialState,
    reducers: {
        onFetchSubCategories (state, { payload }: { payload: Subcategory[]}) {
            state.status = ApiStatus.FETCHED
            state.subCategories = payload
            state.errorMessage = undefined
        },
        onFetchSubcategoriesWithProduct (state, { payload }: { payload: Subcategory[]}) {
            state.status = ApiStatus.FETCHED
            state.subcategoriesWithProducts = payload
            state.errorMessage = undefined
        },
        onSetSelectedSubCategory (state, { payload }: { payload: Subcategory }) {
            state.subCategorySelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSubCategoryState = (state: RootState) => state.subcategorySlice
export default subcategorySlice.reducer
export const {
    onFetchSubCategories,
    onFetchSubcategoriesWithProduct,
    onSetSelectedSubCategory,
    changeStatus,
    setAction,
} = subcategorySlice.actions
